module.exports = __webpack_public_path__ + "img/610.2ab52faf.jpg";